import React from "react";

const AlertBanner = ({ type = "info", message, onClose }) => (
  <div className={`billr-alert ${type}`}>
    <span style={{ flex: 1 }}>{message}</span>
    {onClose && (
      <button
        type="button"
        onClick={onClose}
        style={{ background: "none", border: "none", cursor: "pointer", opacity: 0.6, fontSize: "1.1rem" }}
      >
        ×
      </button>
    )}
  </div>
);

export default AlertBanner;
